namespace TabAurous.Master {
    export interface DesignationForm {
        DesignationName: Serenity.StringEditor;
        Level: Serenity.StringEditor;
        LeaveDays: Serenity.DecimalEditor;
        AdvanceAmount: Serenity.DecimalEditor;
        Narration: Serenity.StringEditor;
    }

    export class DesignationForm extends Serenity.PrefixedContext {
        static formKey = 'Fynamics.Designation';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DesignationForm.init)  {
                DesignationForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DecimalEditor;

                Q.initFormType(DesignationForm, [
                    'DesignationName', w0,
                    'Level', w0,
                    'LeaveDays', w1,
                    'AdvanceAmount', w1,
                    'Narration', w0
                ]);
            }
        }
    }
}
